'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TabSwitcher = _react2['default'].createClass({
    displayName: 'TabSwitcher',


    propTypes: {
        onNextClick: _react2['default'].PropTypes.func.isRequired,
        onPrevClick: _react2['default'].PropTypes.func.isRequired
    },

    onNextClick: function onNextClick() {
        this.props.onNextClick();
    },

    onPrevClick: function onPrevClick() {
        this.props.onPrevClick();
    },

    render: function render() {
        return _jsx('div', {
            className: 'hide-for-large-up'
        }, void 0, _jsx('div', {
            className: 'm-tabs--switcher right',
            onClick: this.onNextClick
        }, void 0, _jsx('img', {
            className: 'm-tabs--right-arrow',
            src: require("./arrow_right@2x.png")
        })), _jsx('div', {
            className: 'm-tabs--switcher left',
            onClick: this.onPrevClick
        }, void 0, _jsx('img', {
            className: 'm-tabs--left-arrow',
            src: require("./arrow_left@2x.png")
        })));
    }
});

module.exports = TabSwitcher;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/tabbed-area/tab-switcher.jsx
 ** module id = 798
 ** module chunks = 0
 **/